import { useMapGetter } from 'dashboard/composables/store.js';
import { BRAND_NAME } from 'shared/constants/brand';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" (any casing) in text with the installation name from
   * global config, falling back to the BNar override (BRAND_NAME) when no
   * installationName is configured on the backend for this account.
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName || BRAND_NAME;
    return text.replace(/chatwoot/gi, installationName);
  };

  return {
    replaceInstallationName,
  };
}
